<p>animated-article-imaged works!</p>
